export default __webpack_public_path__ + "static/media/tet.6b4154a4.obj";